import Swiper from 'swiper';
import SameSizedCards from '../modules/same_sized_cards';
import Form from '../modules/forms/form';
import copyToClipboard from '../util/copyToClipboard';
import debounce from '../util/debounce';
import Components from '../autoload/_components';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import AOS from 'aos';

export default {

    init() {
        this._jScroll = '';
        // JavaScript to be fired on all pages
    },
    finalize() {

        // JavaScript to be fired on all pages, after page specific JS is fired
        this.setDefaults();
        Form.init();
        SameSizedCards.init();
        Components.init();
        this.addEvents();
        this.initSwipers();
        this.initTags();
        lazySizes.init();
    },
    setDefaults() {
        this.jHtml = $(document.body).parent();
    },
    addEvents() {
        $(window).scroll(debounce($.proxy(this._onWinScroll, this), 100));

        $('.jsReferralGotoDashboard').on('click', function () {
          location.href = 'https://carbonateapp.com/dashboard';
        });

        $( '#psg-banner-link a' ).on( 'click', function(e){
            var href = $(this).attr( 'href' );
            var jHeaderHeight = $('.page__header').height();
                $( 'html, body' ).animate({
                scrollTop: $( href ).offset().top - jHeaderHeight}, '5000' );
            
            // Prevent the browser from showing the attribute name of the clicked link in the address bar
            e.preventDefault();
        });

        // $(document).on('click', '#psg-banner-link a', function (e) {
		// 	e.preventDefault();
			
		// 		$('#psg-subsidy-form')[0].scrollIntoView({
		// 			behavior: 'smooth',
		// 		});

		// });

        if ($('.user-guide-detail__steps').length > 0) {
            $('.user-guide-detail__steps').magnificPopup({
                delegate: '.user-guide-detail__step-img-wrapper', // child items selector, by clicking on it popup will open
                type: 'image',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    tCounter: '<span class="mfp-counter">Step %curr%</span>', // markup of counter
                },
                image: {
                    // options for image content type
                    titleSrc: function() {
                        return '';
                    },
                },
                midClick: true,

                // Delay in milliseconds before popup is removed
                removalDelay: 300,

                // Class that is added to popup wrapper and background
                // make it unique to apply your CSS animations just to this exact popup
                mainClass: 'mfp-fade',

                // other options
            });
        }

        

       
        
        $('.rhad-creative__nav-image').click(function () {
            $('.rhad-creative__nav-image').removeClass('active');
            // $(".tab").addClass("active"); // instead of this do the below 
            $(this).addClass('active');   
         });
        
          $('.jsShowSingle').click(function () {
            var hero = $( this ).data( 'hero' );
            $( '.jsHero' ).hide();
            $( `#${hero}, #${hero}-img` ).fadeIn(2000);
           });
        

        $('.jsLeftNavLink').on('change', function(e) {
            var jTarget = $(e.delegateTarget);
            location.href = jTarget.find(':selected').data('href');
        });

        $('.jsScrollTop').on('click', function() {
            $('html, body').animate({
                scrollTop: 0,
                behavior: 'smooth',
            }, 1000);

        });
        $(window).scroll(function() {
            if ($(window).scrollTop() > 250 ) {
                $('.jsScrollTop').removeClass('g-hidden');
                $('.jsScrollTop').addClass('position_fix');
            } else {
                $('.jsScrollTop').addClass('g-hidden');

            }
        });

        this._checkScrollAndUpdateTop();
        if ($(window).width() < 767) {
            $('#scroll__top').click(function() {
                // e.preventDefault();
                $('html, body').animate({
                    scrollTop: '0',
                }, 400);
            });
        } else {
            $('#scroll__top').hide();
        }
        $('.thanks__urlcopy').on('click', function() {
            copyToClipboard($('.thanks__url').html().trim());
            $('.thanks__urlcopy').addClass('active');

            setTimeout(function() {
                $('.thanks__urlcopy').removeClass('active')
            }, 3000);

        });
        // Add Google anlytics code here
        // $('.jsAnalytics').click(function() {
        //   var buttonText = $(this).text();
        //   var pageTitle = $(this).attr('data-title');
        //   // ga('send', 'event', pageTitle, 'click', buttonText);
        // });
    },
    initSwipers() {
        // Horizontal Swipers
        new Swiper($('.jsSwiper.jsHorizontalSwiper')[0], {
            autoplay: {
                delay: 1000000,
            },
            slidesPerView: 'auto',
            loop: false,
            speed: 600,
            freeMode: true,
            observer: true,
            observeParents: true,
        });
    },
    initTags() {
        if ($('.jsSelectMultiple.jsSelectTags').length > 0) {
            // let select2Instance;
            //$('.jsSelectMultiple.jsSelectTags').select2();

            $('.jsSelectMultiple.jsSelectTags').select2({
                multiple: true,
                createTag: function() {
                    return null;
                },
            });
            // Patch to clear the selections in the begining
            // select2Instance.val(null).trigger('change');
        }
    },

    _onWinScroll: function() {
        this._checkScrollAndUpdateTop();
    },
    _checkScrollAndUpdateTop: function() {
        if ($(window).scrollTop() > 300) {
            if ($(window).width() < 767) {
                $('#scroll__top').show();
            }
        } else {
            $('#scroll__top').hide();
        }
    },
    

    
};

$('.mob-noscroll').click(function () {
    if($('body').hasClass('notscroll')){
        $('body').removeClass('notscroll');
    }else{
        $('body').addClass('notscroll');
    }
});

$('#contactFromSpace').keypress(function(e){
    if(e.which === 32) {
        return false; 
    }
});

$('.jsContactEmailNoSpace').keypress(function(e){
    if(e.which === 32) {
        return false; 
    }
});

document.onreadystatechange = function () {
    var state = document.readyState
    if (state == 'interactive') {
         document.getElementById('jsRahdPageContent').style.visibility='hidden';
    } else if (state == 'complete') {
        setTimeout(function(){
           document.getElementById('interactive');
           document.getElementById('jsRahdPageLoader').style.visibility='hidden';
           document.getElementById('jsRahdPageContent').style.visibility='visible';
        },500);
    }
  }
$(function() {
    AOS.init();
});
$(document).ready(function () {
    $('#psg-banner-link a').click(function () {
        // alert('This is an alert message!');
    });

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        //console.log(event);
        if(event.detail.contactFormId == 5619 || event.detail.contactFormId == 5597 && event.detail.status == 'mail_sent' ){
   
              window.location.href = '/thank-you/';
         }
            
     }, true );
});




// WEBPACK FOOTER //
// ./scripts/routes/common.js